import React, { useEffect, useState } from 'react';
import { Container } from './styles';
import MainTitle from 'components/MainTitle';
import Heading from 'components/Heading';
import AccommodationSeturForm from './components/AccommodationSeturForm/index';
import { useParams } from 'react-router';
import { useLoading } from 'hooks/useLoading';
import TouristOffersBusinessService from 'services/TouristOffersBusinessService';

const AccommodationForm = (): JSX.Element => {
  const { id } = useParams<{ id?: string }>();
  const { openLoading, closeLoading } = useLoading();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [selectedAccommodation, setSelectedAccommodation] = useState<any>(null);

  useEffect(() => {
    openLoading();
    const fetchBusinessAccommodationData = [fetchTouristOffersAccommodation()];
    Promise.all(fetchBusinessAccommodationData).finally(() => closeLoading());
  }, []);

  const service = new TouristOffersBusinessService();

  const fetchTouristOffersAccommodation = async () => {
    if (id) {
      try {
        const data = await service.findOne(Number(id));
        const images = (data?.images || [])
          .filter(image => image.description !== 'Estruturas Anexas')
          .map(image => image.image);
        const structures = (data?.images || [])
          .filter(image => image.description === 'Estruturas Anexas')
          .map(image => image.image);
        const newAccommodation = {
          ...data,
          images,
          image: data?.image ? [data.image] : [],
          structures,
        };
        setSelectedAccommodation(newAccommodation);
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      <MainTitle>Configurações</MainTitle>
      <Container>
        <Heading>{id ? 'Editar Hospedagem' : 'Nova Hospedagem'}</Heading>
        <AccommodationSeturForm selectedId={id} item={selectedAccommodation} />
      </Container>
    </>
  );
};

export default AccommodationForm;
